import { type ReactElement, Suspense } from "react";
import cx from "classnames";
import UserRole from "@olivahealth/business/src/Core/domain/value-objects/UserRole";
import SidebarPlaceholder from "../../../rebrand/organisms/SidebarPlaceholder";
import ImpersonatorBanner from "../../../rebrand/organisms/ImpersonatorBanner";
import Header from "../../../rebrand/organisms/Header";
import Sidebar from "../../../rebrand/organisms/Sidebar";
import PostSessionSatisfactionDialog from "../../../scenes/PostSessionSatisfactionSurvey/PostSessionSatisfactionDialog";
import AdminConsole from "../AdminConsole";
import { useUserData } from "../../../services/contexts/UserDataContext";
import * as s from "./styles";

interface IProps {
  showLogo?: boolean;
  showSidebar?: boolean;
  showNavBar?: boolean;
  children: React.ReactNode;
}

/**
 * This component provides a base layout to be shared across all pages
 */
export default function AppLayout({
  showLogo = true,
  showSidebar = true,
  showNavBar = true,
  children,
}: IProps): ReactElement {
  const { data: userData } = useUserData();
  const lightVariant = userData?.role?.includes(UserRole.MHP) ?? false;
  return (
    <>
      <Suspense fallback={null}>
        <Header showLogo={showLogo} showNavBar={showNavBar} />
      </Suspense>
      {showSidebar && (
        <Suspense fallback={<SidebarPlaceholder />}>
          <Sidebar />
        </Suspense>
      )}
      <AdminConsole />
      <section
        className={cx("h-auto", {
          "md:ml-80": showSidebar && lightVariant,
          "md:ml-56": showSidebar && !lightVariant,
          "md:w-full": !showSidebar,
        })}
      >
        {/* README: MFA banner functionality is broken so we're hiding it for now */}
        {/* <MfaBanner /> */}
        <ImpersonatorBanner />
      </section>
      <main
        className={cx(s.mainContent, {
          "md:ml-80": showSidebar && lightVariant,
          "md:ml-56": showSidebar && !lightVariant,
          "md:w-full": !showSidebar,
        })}
      >
        {children}
      </main>
      <PostSessionSatisfactionDialog />
    </>
  );
}
